import React, { useEffect, useState, useCallback } from "react";
import { GoProjectSymlink } from "react-icons/go";
import { SiGoogleadsense } from "react-icons/si";
import { GrProjects } from "react-icons/gr";
import { IoSettingsOutline } from "react-icons/io5";
import Submenu, { subMenus } from "./SubSidebar";
import splogo from "../assets/splogo.png";
import { useLocation } from "react-router-dom";

const initialMenuItems = [
  {
    name: "All Projects",
    icon: GoProjectSymlink,
    visible: true,
    id: "allProjects",
  },
  { name: "Paid Ads", icon: SiGoogleadsense, visible: false, id: "paidAds" },
  { name: "Tools", icon: GrProjects, visible: true, id: "tools" },
  { name: "Admin", icon: IoSettingsOutline, visible: true, id: "admin" },
];

const Sidebar = () => {
  const [activeMenu, setActiveMenu] = useState(null);
  const [menuItems, setMenuItems] = useState(initialMenuItems);
  const location = useLocation();

  const updateMenuItemsBasedOnStorage = useCallback(() => {
    const customerId = localStorage.getItem("customer_id");
    const isCustomerConnected = customerId && customerId !== "Not Connected";

    const shouldHidePaidAds =
      location.pathname === "/projects" ||
      location.pathname === "/ads-project-performance";

    setMenuItems((prevItems) =>
      prevItems.map((item) => {
        if (item.id === "paidAds") {
          return {
            ...item,
            visible: isCustomerConnected && !shouldHidePaidAds,
          };
        }
        return item;
      }),
    );
  }, [location.pathname]);

  useEffect(() => {
    updateMenuItemsBasedOnStorage();
  }, [location.pathname, updateMenuItemsBasedOnStorage]);

  const getActiveMenuFromPath = useCallback(() => {
    const currentPath = location.pathname;

    if (currentPath === "/") return "All Projects";

    for (const [menuName, items] of Object.entries(subMenus)) {
      for (const subItem of items) {
        const basePath = subItem.path.split("/:")[0];
        if (currentPath.startsWith(basePath) && basePath !== "/") {
          return menuName;
        }
      }
    }
    return null;
  }, [location.pathname]);

  return (
    <div className="flex h-screen bg-gray-100">
      <div className="w-24 bg-gray-50 text-gray-600 flex flex-col items-center py-6 space-y-4 shadow-md font-bold">
        {/* Logo */}
        <img
          src={splogo}
          alt="Logo"
          className="w-9 h-9 mb-4 cursor-pointer"
          onClick={() => setActiveMenu(null)}
        />

        {menuItems
          .filter((item) => item.visible)
          .map((item) => {
            const activeRouteMenu = getActiveMenuFromPath();

            const isHighlighted = activeMenu
              ? activeMenu === item.name
              : activeRouteMenu === item.name;

            return (
              <div
                key={item.id}
                className={`w-[84px] h-[80px] flex flex-col items-center justify-center p-2 rounded-xl cursor-pointer transition-all ${
                  isHighlighted
                    ? "bg-blue-100 text-blue-600"
                    : "hover:bg-gray-100"
                }`}
                onClick={() =>
                  setActiveMenu(activeMenu === item.name ? null : item.name)
                }
              >
                <item.icon className="w-7 h-7 mb-1" />
                <span className="text-[11px] text-center leading-tight">
                  {item.name}
                </span>
              </div>
            );
          })}
      </div>

      {activeMenu && (
        <Submenu menu={activeMenu} onClose={() => setActiveMenu(null)} />
      )}
    </div>
  );
};

export default Sidebar;
